import React from "react";
import PropTypes from "prop-types";
import { Icon } from "../../../../../atoms/icon";
import { copyToClipboard } from "../../../../../utils/utils";

import styles from "./styles.m.css";

export class SocialShareTemplate extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.state = {
      showCopiedModal: false
    };
  }

  handleClick() {
    try {
      if (copyToClipboard(window.location.href)) {
        this.setState({
          showCopiedModal: true
        });

        setTimeout(() => {
          this.setState({
            showCopiedModal: false
          });
        }, 3000);
      } else {
        // how to convey failure to user
      }
    } catch (err) {
      console.log(err.message);
    }
  }

  render() {
    const { fbUrl, twitterUrl, mailtoUrl, whatsappUrl, handleShare, className } = this.props;
    return (
      <div className={`${className} ${styles["social-share"]}`}>
        <ul className={`${styles["social-share__icons"]}`}>
          <li className={styles["share-label"]}> Share via :</li>
          <li className={`${styles["social-share__icon"]} ${styles["social-share__icon--whatsapp"]}`}>
            <a
              aria-label="whatsapp share"
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles["social-share__link"]} ${styles["social-share__whatsapp-icon"]}`}
            >
              <Icon type="whatsapp" />
            </a>
          </li>

          <li className={`${styles["social-share__icon"]} ${styles["social-share__icon--facebook"]}`}>
            <a
              aria-label="facebook share"
              href={fbUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles["social-share__link"]} ${styles["social-share__fb-icon"]}`}
            >
              <Icon type="facebook-bg" />
            </a>
          </li>
          <li className={`${styles["social-share__icon"]} ${styles["social-share__icon-twitter"]}`}>
            <a
              aria-label="twitter share"
              href={twitterUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={`${styles["social-share__link"]} ${styles["social-share__twitter--icon"]}`}
            >
              <Icon type="twitter" />
            </a>
          </li>
          <li className={`${styles["social-share__icon"]} ${styles["social-share__icon--email"]}`}>
            <a
              aria-label="e-mail share"
              href={mailtoUrl}
              className={`${styles["social-share__link"]} ${styles["social-share__email-icon"]}`}
            >
              <Icon type="email" />
            </a>
          </li>

          {handleShare && (
            <li className={`${styles["social-share__icon"]} ${styles["social-share__icon--app-share"]}`}>
              <button
                aria-label="Share this"
                onClick={handleShare}
                className={`${styles["social-share__link"]} ${styles["social-share__share-app-share"]}`}
                role="button"
              >
                <Icon type="mobile-share" />
              </button>
            </li>
          )}

          <li className={`${styles["social-share__icon"]} ${styles["social-share__icon--copy"]}`}>
            {this.state.showCopiedModal && <span className={styles["copy-modal"]}>Copied story url for sharing</span>}
            <button
              aria-label="show message"
              role="button"
              onClick={this.handleClick}
              className={`${styles["social-share__link"]} ${styles["social-share__copy-icon"]}`}
            >
              <Icon type="clipboard" />
            </button>
          </li>
        </ul>
      </div>
    );
  }
}

SocialShareTemplate.propTypes = {
  className: PropTypes.string,
  fbUrl: PropTypes.string,
  twitterUrl: PropTypes.string,
  mailtoUrl: PropTypes.string,
  whatsappUrl: PropTypes.string,
  handleShare: PropTypes.func,
  color: PropTypes.string
};
